export const formatPhone = (phone: string | undefined): string => {
  if (!phone) return "";

  // Remove all non-numeric characters
  let cleaned = phone.replace(/\D/g, "");

  // Handle numbers with country code
  if (cleaned.length === 11 && cleaned.startsWith("1")) {
    cleaned = cleaned.slice(1);
  }

  // Format as +1 (XXX) XXX-XXXX if 10 digits
  if (cleaned.length === 10) {
    return `+1 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
      6
    )}`;
  }

  // If not 10 digits, just return cleaned number with +1
  return `+1 ${cleaned}`;
};
